import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ViContentComponent } from '../content/content.component';
import { CommonStandaloneModule } from '../../../../app/shared/common-standalone.module';

@Component({
  selector: 'vi-header',
  standalone: true,
  imports: [CommonStandaloneModule, ViContentComponent],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViHeaderComponent {
  @Input() color: 'viorange' | 'eclipse' | 'white';

  @Input() shadow = true;

  @Input() gap: string = '20px';
  @Input() height: string;
  @Input() layoutAlign: string;
  @Input() direction: string = 'col';
  @Input() fluid: boolean;
  @Input() twoColumns: boolean;
  @Input() centered: boolean;
}
